export default {
    /**
     * Adds the user's email address during the registration process.
     *
     * @param {object} state
     * @param {string} userEmail
     */
    addUserEmail(state, userEmail) {
        state.userSignup.email = userEmail;
    },

    /**
     * Adds the user's phone number during the registration process.
     *
     * @param {object} state
     * @param {string} userPhone
     */
    addUserPhoneNumber(state, userPhone) {
        state.userSignup.phoneNumber = userPhone;
    },

    /**
     * Adds the user's id during the registration process.
     *
     * @param {object} state
     * @param {number} userId
     */
    addUserId(state, userId) {
        state.userSignup.userId = userId;
    },
}
